// Tournament configuration constants

export const ROUND_NAMES = {
  ko: {
    32: '32강',
    16: '16강',
    8: '8강',
    4: '준결승',
    2: '결승',
  },
  en: {
    32: 'Round of 32',
    16: 'Round of 16',
    8: 'Quarterfinals',
    4: 'Semifinals',
    2: 'Finals',
  },
};

export const ANIMATION_DELAYS = {
  CARD_SELECTION: 600,
  MATCH_TRANSITION: 800,
  WINNER_REVEAL: 1000,
};

export const DEFAULT_TOURNAMENT_SIZE = 16;

export const TOURNAMENT_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  SHOWING_RANKINGS: 'SHOWING_RANKINGS',
};

export const SELECTION_STATE = {
  IDLE: 'IDLE',
  WINNER: 'WINNER',
  LOSER: 'LOSER',
};

export const UI_TEXT = {
  ko: {
    loading: '토너먼트를 준비 중입니다...',
    champion: '우승!',
    restart: '다시 하기',
    share: '공유하기',
    twitter: '트위터',
    facebook: '페이스북',
    copyLink: '링크 복사',
    copied: '복사됨!',
    shareMessage: (name) => `내 이상형은 "${name}"! 울타리컵에서 우승했어요 🏆`,
    shareTitle: '울타리컵 결과',
    showRankings: '랭킹보기',
    rankingsTitle: '전체 랭킹',
    backToResult: '결과로 돌아가기',
    rankingRank: '순위',
    rankingName: '이름',
    rankingBar: '득표율',
    rankingWins: '득표수',
    alreadyPlayed: '오늘은 이미 참여하셨습니다',
    alreadyPlayedDesc: '내일 다시 도전해주세요!',
  },
  en: {
    loading: 'Preparing tournament...',
    champion: 'Champion!',
    restart: 'Play Again',
    share: 'Share',
    twitter: 'Twitter',
    facebook: 'Facebook',
    copyLink: 'Copy Link',
    copied: 'Copied!',
    shareMessage: (name) => `My ideal type is "${name}"! Winner of WooltariCup 🏆`,
    shareTitle: 'WooltariCup Results',
    showRankings: 'Show Rankings',
    rankingsTitle: 'Overall Rankings',
    backToResult: 'Back to Results',
    rankingRank: 'Rank',
    rankingName: 'Name',
    rankingBar: 'Vote Rate',
    rankingWins: 'Votes',
    alreadyPlayed: 'You have already played today',
    alreadyPlayedDesc: 'Please come back tomorrow!',
  },
};